import React from 'react'
import {Modal} from 'react-bootstrap'

import './PortfolioImage.css'

export default class PortfolioImage extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            showModal: false
        }
    }

    closeModal () {
        this.setState({showModal: false})
    }

    openImage () {
        this.setState({showModal: true})
    }

    render () {
        return (
            <div className="portfolio-image-wrapper"
                onClick={this.openImage.bind(this)}>
                <Modal show={this.state.showModal}
                       onHide={this.closeModal.bind(this)}
                       bsSize="large">
                    <Modal.Body>
                        <img src={this.props.src} width="100%" role="presentation" />
                    </Modal.Body>
                </Modal>

                <img className="portfolio-image"
                     role="presentation"
                     src={this.props.src} />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/portfolio/PortfolioImage.js